import { LabMDM } from "../masterdata/models/lab";
import { Printer } from "../masterdata/models/printer";

export class PrintRequest {
    barCode: string[] = [];
    lab: LabMDM;
    printer: Printer;
    numberOfCopies?: number;
    templateString?: string;
}